import React from 'react'

const styles = {
  label: {
    fontWeight: 500,
    color: '#F2F2F2',
    fontSize: '15px',
    marginLeft: '10px'
  },
  textarea: {
    backgroundColor: '#374148',
    borderWidth: '0px',
    width: '320px',
    borderRadius: '10px',
    color: '#F2F2F2',
    fontSize: '15px',
    paddingLeft: '10px',
    paddingTop: '10px',
    fontWeight: 500,
    fontStyle: 'normal'
  }
}

class NoteComponent extends React.Component {
  render () {
    return (
      <div>
        <textarea
          placeholder={this.props.label}
          style={styles.textarea}
          value={this.props.value}
          onChange={(event) => this.props.onChange(event.target.value)}
          rows={6}
          cols={40}
        />
      </div>
    )
  }
}

export default NoteComponent
